import { api } from '@/api'
import type { ApiPaginationResponse, ApiResponse } from '@/api/typings/response.typing'
import type { PostItem } from '@/api/typings/settings.typing'

export function getPostsAction(page: number = 1): Promise<ApiPaginationResponse<PostItem[]>> {
  return api.get<ApiPaginationResponse<PostItem[]>>(`/posts?page=${page}`)
}

export function getPostAction(slug: string): Promise<ApiResponse<PostItem>> {
  return api.get<ApiResponse<PostItem>>(`/posts/${slug}`)
}

export function updatePostAction(
  slug: string,
  payload: { title: string; content: string; image?: File }
): Promise<ApiResponse<PostItem>> {
  const formData = new FormData()
  formData.append('title', payload.title)
  formData.append('content', payload.content)
  formData.append('_method', 'PUT')
  if (payload.image) formData.append('image', payload.image)

  return api.post<ApiResponse<PostItem>>(`/posts/${slug}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export function createPostAction(payload: {
  title: string
  content: string
  image?: File | unknown
}): Promise<ApiResponse<PostItem>> {
  const formData = new FormData()
  formData.append('title', payload.title)
  formData.append('content', payload.content)
  if (payload.image) formData.append('image', payload.image as File)

  return api.post<ApiResponse<PostItem>>(`/posts`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export function deletePostAction(ids: string[]): Promise<ApiResponse<null>> {
  return api.delete<ApiResponse<null>>(`/posts`, {
    body: {
      id: ids,
    },
  })
}
